export { default } from './license.js';
